import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import BasicSegmentString from '../noding/BasicSegmentString';
import FastNodingValidator from '../noding/FastNodingValidator';
import ArrayList from '../../../../java/util/ArrayList';
var EdgeNodingValidator = /*#__PURE__*/function () {
  function EdgeNodingValidator() {
    _classCallCheck(this, EdgeNodingValidator);
    EdgeNodingValidator.constructor_.apply(this, arguments);
  }
  _createClass(EdgeNodingValidator, [{
    key: "checkValid",
    value: function checkValid() {
      this._nv.checkValid();
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._nv = null;
      var edges = arguments[0];
      this._nv = new FastNodingValidator(EdgeNodingValidator.toSegmentStrings(edges));
    }
  }, {
    key: "toSegmentStrings",
    value: function toSegmentStrings(edges) {
      var segStrings = new ArrayList();
      for (var i = edges.iterator(); i.hasNext();) {
        var e = i.next();
        segStrings.add(new BasicSegmentString(e.getCoordinates(), e));
      }
      return segStrings;
    }
  }, {
    key: "checkValid",
    value: function checkValid(edges) {
      var validator = new EdgeNodingValidator(edges);
      validator.checkValid();
    }
  }]);
  return EdgeNodingValidator;
}();
export { EdgeNodingValidator as default };